<template lang="pug">
  include ../mixins
  div
    slot(v-if="!results")
    +b.ma.--top_xs.--top_3xs-lg(v-if="results")
      renderer(
        :result="results"
        class-render="g-row g-row--space_2sm-lg g-row--appearance_spaced"
      )
    +b.ma.--top_2md(v-if="!pagination.last && !isLoad")
      +b.g-row.--justify_center
        +b.g-cell
          bem-button(
            width="full"
            block="ls-button"
            appearance="yellow"
            @event="getData"
          ) {{ _('Загрузить еще') }}
    +b.spinner--sm.--accent-1(v-if="isLoad")
</template>

<script>
import { newsCatalogResource } from '@/js/services/news.service.js'

export default {
  name: 'news-catalog',

  props: {
    catalogPagination: Object,
    label: String,
  },

  data() {
    return {
      isLoad: false,
      page: 0,
      pagination: this.catalogPagination,
      results: '',
    }
  },

  methods: {
    async request() {
      const params = {
        page: this.page,
        label: this.label,
      }

      await newsCatalogResource.execute(params).then(({ data, meta }) => {
        this.results += data
        this.pagination = meta
      })
    },

    async getData() {
      if (!this.pagination.last) {
        const updateData = async () => {
          ++this.page
          await this.request()
        }

        this.isLoad = true

        if (!this.page) {
          await updateData()
          await updateData()
        } else {
          await updateData()
        }
        this.isLoad = false
      }
    },
  },
}
</script>
